import { Component, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { EventEmitter } from 'stream';

@Component({
  selector: 'app-expert',
  templateUrl: './expert.component.html',
  styleUrls: ['./expert.component.scss',],
})
export class ExpertComponent {

  @Input() emailId: string = '';

  constructor(
    private _router: Router
  ) { }

  navigate() {
    this._router.navigateByUrl('contact-us');
  }
}
